import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "error-detail-box mb-4" }
const _hoisted_2 = { class: "d-block mb-1" }
const _hoisted_3 = { class: "error-steps" }

import { ref, computed } from 'vue';
import type { LienData } from '@/models/lienTypes';
import { resolveQboPushError, resolveQboPushSteps } from '@/utils/lienHelpers';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import QboIcon from '@/components/QboIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LienPushErrorDialog',
  setup(__props, { expose: __expose }) {

const isVisible = ref(false);
const lien = ref<LienData | null>(null);
let resolvePromise: ((value: 'retry' | 'close') => void) | null = null;

const message = computed(() => resolveQboPushError(lien.value?.qboPushError, lien.value?.qboPushError));
const steps = computed(() => resolveQboPushSteps(lien.value?.qboPushError));
// Reconciled checks cannot be retried, nor can a lien trust can't cover yet (same gate as canRetryLien).
const canRetry = computed(
  () => lien.value?.qboPushError !== 'RECONCILED_CHECK' && !lien.value?.pushBlockedReason,
);

/** Open the error detail for a failed lien; resolves 'retry' or 'close'. */
function open(target: LienData): Promise<'retry' | 'close'> {
  lien.value = target;
  isVisible.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
}

function close(): void {
  isVisible.value = false;
  resolvePromise?.('close');
  resolvePromise = null;
}

function retry(): void {
  isVisible.value = false;
  resolvePromise?.('retry');
  resolvePromise = null;
}

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isVisible).value = $event)),
    "max-width": "480",
    "data-cy": "push-error-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Submit Error Details", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("strong", _hoisted_2, _toDisplayString(lien.value?.vendorDisplayName), 1),
                _createElementVNode("span", null, _toDisplayString(message.value), 1)
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-body-2 font-weight-bold text-grey-darken-3 mb-2" }, " Suggested resolution steps: ", -1)),
              _createElementVNode("ol", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(step), 1))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(LlSecondaryButton, {
                "data-cy": "push-error-close",
                onClick: close
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Close ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              (canRetry.value)
                ? (_openBlock(), _createBlock(LlSecondaryButton, {
                    key: 0,
                    color: "primary",
                    "data-cy": "push-error-retry",
                    onClick: retry
                  }, {
                    default: _withCtx(() => [
                      _createVNode(QboIcon, {
                        size: 16,
                        class: "mr-2"
                      }),
                      _cache[4] || (_cache[4] = _createTextVNode(" Retry Submit ", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})